<div>
    <app-icon *ngIf="isVisible" ic="IcSuccessColored" size="s"></app-icon>
    <app-icon *ngIf="!isVisible" ic="IcErrorColored" size="s"></app-icon>
</div>
